module.exports = __webpack_public_path__ + "img/base.da7dbf5f.png";